/**
 * Company: SPHMedia
 * Description: [Article page follow topic component]
 */

import FollowTopicsButton from "@elements/FollowTopicsButton/FollowTopicsButton";
import { ReactElement } from "react";

type ArticleFollowTopicProps = {
  label: string;
  topicId: string;
  onFollow: (topicId: string, topicTitle: string) => Promise<void>;
  onUnfollow: (topicId: string, topicTitle: string) => Promise<void>;
  isFollowing: boolean;
  loggedIn?: boolean;
  isLoading?: boolean;
};

/**
 * ArticleFollowTopic
 * Description: [Follow topic component for article page]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function ArticleFollowTopic(
  props: ArticleFollowTopicProps,
): ReactElement {
  const {
    label,
    topicId,
    onFollow,
    onUnfollow,
    isFollowing,
    loggedIn = false,
    isLoading = false,
  } = props;

  return (
    <div
      data-testid="article-follow-topic"
      className="flex justify-between items-center py-3 lg:py-4 border-y border-border-strong"
    >
      <div
        data-testid="follow-label"
        className="text-text-muted text-xs font-semimedium leading-[150%]"
      >
        Ikuti topik ini:
      </div>
      <div className="flex flex-col justify-center items-end gap-1">
        <FollowTopicsButton
          label={label}
          topicId={topicId}
          isFollowing={isFollowing}
          onFollow={onFollow}
          onUnfollow={onUnfollow}
          isLoading={isLoading}
        />
        {!loggedIn && (
          <div
            data-testid="login-prompt"
            className="text-text-muted text-xxs font-regular leading-[150%]"
          >
            Log masuk untuk ikuti
          </div>
        )}
      </div>
    </div>
  );
}
